<template>
  <router-view />
</template>
<script>

import {mapActions} from 'vuex';

export default {
  name: 'Settings',

  /** mixins **/
  mixins: [],

  /** props **/
  props: {},

  /** data **/
  data() {
    return {};
  },

  /** methods**/
  methods: {
    ...mapActions(
        [
          'reset_form_data',
          'resetVessels',
          'reset_rank_keys',
          'reset_key_objects'
        ],
    ),
  },

  /**  computed  **/
  computed: {},

  /** mounted **/
  mounted() {
  },

  /** created **/
  created() {
  },

  /** watch
   searchText : {
			handler : 'fetchUserList',
			immediate : true,
		}
   **/
  watch: {},

  /** destroyed **/
  destroyed() {
    this.reset_form_data();
    this.resetVessels();
    this.reset_rank_keys();
    this.reset_key_objects();
  },

};
</script>

<style scoped>

</style>
